import { translate } from '@teamleader/i18n';
import cx from 'classnames';
import React, { useMemo } from 'react';

import MethodsSkeleton from './MethodsSkeleton';
import * as styles from './styles.css';
import StripeImg from '../../../../../../public/img/creditcard@2x.png';
import Box from '../../../../../Components/UI/Box';
import Spinner from '../../../../../Components/UI/Spinner';
import { PaymentMethod } from '../../../../../Types/payment';

interface PaymentMethodsProps {
  paymentMethods?: PaymentMethod[];
  onClick: (method: PaymentMethod) => void;
  selectedPaymentMethod?: PaymentMethod;
}

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ onClick, paymentMethods, selectedPaymentMethod }) => {
  const paymentMethodOverrides: Record<string, Partial<PaymentMethod>> = useMemo(
    () => ({
      'stripe-card': {
        description: translate('paymentMethods.stripeCard'),
        imageUrl: StripeImg,
      },
    }),
    [],
  );

  const transformedPaymentMethods = useMemo(() => {
    if (!paymentMethods) {
      return;
    }

    return paymentMethods
      .map((paymentMethod) => {
        const override = paymentMethodOverrides[paymentMethod.id];
        return override ? { ...paymentMethod, ...override } : paymentMethod;
      })
      .sort((a, b) => a.description.localeCompare(b.description));
  }, [paymentMethodOverrides, paymentMethods]);

  return (
    <Box className={styles['payment-methods']}>
      {transformedPaymentMethods ? (
        transformedPaymentMethods.map((method: PaymentMethod) => (
          <Box
            element="button"
            key={method.id}
            onClick={() => onClick(method)}
            className={cx(styles['payment-methods-button'], {
              [styles['payment-methods-button--selected']]: selectedPaymentMethod?.id === method.id,
            })}
            disabled={!!selectedPaymentMethod}
          >
            <Box display="flex" flexDirection="row" alignItems="center">
              <Box marginRight={2} display="flex" alignItems="center">
                <img src={method.imageUrl} title={method.description} height={24} width={32} />
              </Box>
              <Box element="span">{method.description}</Box>
            </Box>
            {selectedPaymentMethod?.id === method.id && <Spinner size="small" />}
          </Box>
        ))
      ) : (
        <MethodsSkeleton />
      )}
    </Box>
  );
};

export default PaymentMethods;
